<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark class="mb-2" v-on="on"
          >Nueva Encuesta</v-btn
        >
      </template>
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <progress-bar :show="form.busy"></progress-bar>
            <form
              @submit.prevent="createSurvey"
              @keydown="form.onKeydown($event)"
            >
              <v-card-title primary-title>
                <h3 v-if="!editingSurvey" class="headline mb-0">
                  Crear Encuesta
                </h3>
                <h3 v-else class="headline mb-0">Editar Encuesta</h3>
              </v-card-title>

              <v-card-text>
                <v-text-field
                  name="name"
                  label="Nombre"
                  v-validate="'required'"
                  v-model="form.name"
                ></v-text-field>

                <v-textarea
                  name="description"
                  label="Descripcion"
                  v-validate="'required'"
                  v-model="form.description"
                ></v-textarea>

                <select-input
                  :form="form"
                  :items="surveyTypes"
                  label="Tipo de encuesta"
                  :v-errors="errors"
                  :value.sync="form.type"
                  name="type"
                  v-validate="'required'"
                ></select-input>

                <check-input
                  name="public"
                  :form="form"
                  label="Encuesta pública"
                  :value.sync="form.public"
                  :color="'primary'"
                  :v-errors="errors"
                >
                </check-input>
                <div v-if="form.public">
                  <v-layout>
                    <v-flex xs6 px-1>
                      <date-picker
                        :form="form"
                        :label="$t('admissions.settings.form.start_date')"
                        :v-errors="errors"
                        :value.sync="form.start_date"
                        name="start_date"
                      ></date-picker>
                    </v-flex>

                    <v-flex xs6 px-1>
                      <date-picker
                        :form="form"
                        :label="$t('admissions.settings.form.end_date')"
                        :v-errors="errors"
                        :value.sync="form.end_date"
                        name="end_date"
                      ></date-picker>
                    </v-flex>
                  </v-layout>
                </div>

                <check-input
                  name="status"
                  :form="form"
                  label="Activo"
                  :value.sync="form.status"
                  :color="'primary'"
                  :v-errors="errors"
                >
                </check-input>
                <check-input
                  name="is_enrollment"
                  :form="form"
                  label="Aplica matrícula"
                  :value.sync="form.is_enrollment"
                  :color="'primary'"
                  :v-errors="errors"
                >
                </check-input>
              </v-card-text>

              <v-card-actions>
                <submit-button
                  v-if="!editingSurvey"
                  :form="form"
                  label="Guardar"
                ></submit-button>
                <submit-button
                  v-else
                  :form="form"
                  label="Actualizar"
                ></submit-button>
                <v-btn @click="cancelFormSubmit">Cancelar</v-btn>
              </v-card-actions>
            </form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-layout row>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="surveys"
          class="elevation-1 mt-3"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
            <td class="text-xs-center">
              {{ props.item.type == "FML" ? "Familias" : "Estudiantes" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.public == 1 ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">{{ props.item.start_date }}</td>
            <td class="text-xs-center">{{ props.item.end_date }}</td>
            <td class="text-xs-center">
              {{ props.item.status == 1 ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.is_enrollment == 1 ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="editSurvey(props.item)"
                  slot="activator"
                >
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="openQuestions(props.item)"
                  slot="activator"
                >
                  question_answer
                </v-icon>
                <span>Preguntas</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="tryDeleteSurvey(props.item.id)"
                  slot="activator"
                >
                  delete
                </v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="showSurveyQuestions"
      scrollable
      fullscreen
      persistent
      :overlay="false"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showSurveyQuestions = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ surveyQuestions.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <survey-questions :survey="surveyQuestions" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Eliminar
        </v-card-title>

        <v-card-text>
          Desea eliminar la encuesta?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="deleteSurvey">
            Si
          </v-btn>
          <v-btn color="primary" flat @click="deleteDialog = false">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Form from "vform";
import SurveyQuestions from "./survey_questions.vue";

export default {
  name: "survey-creation-view",
  components: {
    "survey-questions": SurveyQuestions
  },
  data() {
    return {
      form: new Form({
        name: "",
        description: "",
        type: "",
        public: false,
        start_date: "",
        end_date: "",
        status: false,
        is_enrollment: false,
      }),
      headers: [
        { text: "Nombre", align: "center", value: "name" },
        { text: "Descripcion", align: "center", value: "description" },
        { text: "Tipo", align: "center", value: "type" },
        { text: "Pública", align: "center", value: "public" },
        { text: "Fecha inicial", align: "center", value: "start_date" },
        { text: "Fecha final", align: "center", value: "end_date" },
        { text: "Activo", align: "center", value: "status" },
        { text: "Aplica matrícula", align: "center", value: "is_enrollment" },
        { text: "Acciones", align: "center", value: "actions" }
      ],
      surveys: [],
      surveyTypes: [
        { value: "FML", text: "Familias" },
        { value: "STU", text: "Estudiantes" }
      ],
      editingSurvey: false,
      dialog: false,
      showSurveyQuestions: false,
      surveyQuestions: {},
      deleteDialog: false,
      surveyToDelete: ""
    };
  },
  watch: {
    deleteDialog(newValue, oldValue) {
      if (!newValue) {
        this.surveyToDelete = "";
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      axios.get("/api/surveys").then(resp => {
        if (resp.status === 200) {
          this.surveys = resp.data.surveys;
        }
      });
    },
    async createSurvey() {
      if (await this.formHasErrors()) return;

      if (this.editingSurvey) {
        this.updateSurvey();
        return;
      }

      const { status } = await this.form.post("/api/surveys");
      if (status === 200) {
        this.init();
        this.form.clear();
        this.form.reset();
        this.dialog = false;
      } else {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "No se pudo crear la encuesta",
          title: "Alerta",
          modal: true
        });
      }
    },
    async updateSurvey() {
      const { status } = await this.form.put("/api/surveys");

      if (status === 200) {
        this.init();
        this.form.clear();
        this.form.reset();
        this.dialog = false;
        this.editingSurvey = false;
      }
    },
    editSurvey(survey) {
      this.editingSurvey = true;
      this.dialog = true;
      this.form = new Form({
        id: survey.id,
        name: survey.name,
        description: survey.description,
        type: survey.type,
        public: survey.public == 1,
        start_date: survey.start_date,
        end_date: survey.end_date,
        status: survey.status == 1,
        is_enrollment: survey.is_enrollment == 1
      });
    },
    tryDeleteSurvey(surveyId) {
      this.surveyToDelete = surveyId;
      this.deleteDialog = true;
    },
    deleteSurvey() {
      const surveyId = this.surveyToDelete;
      this.deleteDialog = false;
      axios.delete(`/api/survey/${surveyId}`).then(resp => {
        if (resp.status === 200) {
          this.surveys = this.surveys.filter(s => s.id !== surveyId);
        }
      });
    },
    cancelFormSubmit() {
      this.form.clear();
      this.form.reset();
      this.dialog = false;
      this.editingSurvey = false;
    },
    openQuestions(survey) {
      this.showSurveyQuestions = true;
      this.surveyQuestions = survey;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/create.vue